/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/modules/shop/components/warenkorb-box/shop.warenkorb-box.component.ts.
 */
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import {AppWarenkorbService} from '../../../../services/app.warenkorb.service';
import {BehaviorSubject, Subject} from 'rxjs';
import {Warenkorb} from '../../../../models/warenkorb';
import {ActivatedRoute, Router} from '@angular/router';
import {AppEventService} from '../../../../services/app.event.service';
import {AppPageloaderService} from '../../../../services/app.pageloader.service';
import {AppViewService} from '../../../../services/app.view.service';
import {WarenkorbEntry} from '../../../../models/warenkorb-entry';
import {AppDialogsService} from '../../../../services/app.dialogs.service';
import {ShopWarenkorbActionInfoComponent} from '../warenkorb-action-info/shop.warenkorb-action-info.component';
import {WarenkorbActionInfo} from '../../../../models/warenkorb-action-info';
import {SectionTitleButton} from '../../../shared/models/section-title-button';
import {AppBackService} from '../../../../services/app.back.service';
import {WarenkorbKategorie} from '../../../../models/warenkorb-kategorie';
import {AppMessageService} from '../../../../services/app.message.service';
import {AppPageTitleService} from '../../../../services/app.page-title.service';
import {AppCrontaskService} from '../../../../services/app.crontask.service';
import {AppSettingsService} from '../../../../services/app.app_settings.service';
import {ShopWarenkorbTableInterface} from '../../interfaces/shop.warenkorb-table-interface';
import {AppConfigService} from '../../../../services/app.config.service';
import {ViewSettings} from '../../../../models/view-settings';
import {AppLieferkundeService} from '../../../../services/app.lieferkunde.service';
import {AppUserService} from '../../../../services/app.user.service';
import {SimplebarAngularComponent} from 'simplebar-angular';
import {AppKeyValueStorageService} from '../../../../services/app.key-value-storage.service';
import {AppSnackbarService} from '../../../../services/app.snackbar.service';
import moment from 'moment';
import {AppAsyncTimeout} from '../../../../helpers/app.asyncTimeout';
import {Supplier} from '../../../../models/supplier';
import {AppSupplierService} from '../../../../services/app.supplier.service';
import {takeUntil} from 'rxjs/operators';
import {ArtikelVerfuegbarkeit} from '../../../../models/artikel-verfuegbarkeit';
import {AppMobileService} from '../../../../services/app.mobile.service';
import {ShopWarenkorbTableComponent} from '../warenkorb-table/shop.warenkorb-table.component';
import {AppImportHinweisService} from '../../../../services/app.import-hinweis.service';
import {ImportHinweisResult} from '../../../../models/import-hinweis';

/**
 * Zweck: Beschreibt class ShopWarenkorbBoxComponent und ihren Daten- oder Funktionsvertrag.
 */
@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'warenkorb-box',
    templateUrl: 'shop.warenkorb-box.component.html',
    styleUrls: ['shop.warenkorb-box.component.scss'],
    standalone: false
})
export class ShopWarenkorbBoxComponent implements OnInit, OnDestroy, OnChanges, ShopWarenkorbTableInterface {

/**
 * Beschreibt Methode constructor und ihren Rückgabevertrag.
 */
  constructor(private route: ActivatedRoute, private svc: AppWarenkorbService, private esvc: AppEventService,
              private loader: AppPageloaderService, private snackBarSvc: AppSnackbarService, public vsvc: AppViewService,
              private dsvc: AppDialogsService, private backsvc: AppBackService, private msg: AppMessageService,
              private tsvc: AppPageTitleService, private router: Router, private ctsvc: AppCrontaskService,
              private settsvc: AppSettingsService, private cd: ChangeDetectorRef, public cfg: AppConfigService,
              public usvc: AppUserService, private lksvc: AppLieferkundeService, public msvc: AppMobileService,
              private kvstorage: AppKeyValueStorageService, private ssvc: AppSupplierService,
              private importHinweisSvc: AppImportHinweisService) {
  }
  @Input() primary_warenkorb: Warenkorb;
  @Input() warenkorb: Warenkorb;
  @Input() send_position_from_bottom = false;
  @Input() with_top_right_actions = true;
  @Input() send_button_pos_fixed = true;

  @Input() buttons_right: SectionTitleButton[] | null = [];
  @Output() buttons_rightChange = new EventEmitter<SectionTitleButton[]>();

  @Output() reload = new EventEmitter();

  @Input() widget_mode = false;
  @Input() ajax_mode = false;
  @Input() selectMode = false;


  @Input() selectedEntries: WarenkorbEntry[] = [];
  @Output() selectedEntriesChange = new EventEmitter<WarenkorbEntry[]>();


  selectedEntriesPerKategorie = {};

  countReadyToSend = new BehaviorSubject<number>(0);

  @ViewChild('wkscroll') wkscroll: SimplebarAngularComponent;
  @ViewChild(ShopWarenkorbTableComponent) warenkorbTable: ShopWarenkorbTableComponent;

  active_fields: string[] = [];
  readonly popupActionFields = ['aktionen_button'];
  readonly hiddenFields = ['hersteller'];
  readonly popupHiddenFields = [...this.hiddenFields, ...this.popupActionFields];
  /** Bewahrt die Position der ausgeblendeten Aktionsspalten für die bisherige Darstellung. */
  private preservedActionFields: {field: string; index: number}[] = [];

  suppliers: BehaviorSubject<Supplier[]> = new BehaviorSubject<Supplier[]>([]);
  selectedSupplier: Supplier;

  group = new BehaviorSubject<boolean>(undefined);
  group_val = true;

  artVResponses = new BehaviorSubject<ArtikelVerfuegbarkeit[]>([]);

  positions: WarenkorbEntry[] = [];

  positionVerfuegbarkeiten: ArtikelVerfuegbarkeit[];

  note_autosave_timeout: any;

  scrollTop: number;
  lockScrollTop = false;

  poscount = 0;

  filter = '';

  label_map = {};

  update_timeout: any = false;
  on_update_timeout: any;
  on_update_timeout_done: any;

  valuta_edited = false;
  liefernAb_edited = false;
  note_edited = false;
  externeKopfreferenz_edited = false;
  reTage_edited = false;
  sortierkennzeichen_edited = false;
  valid = new BehaviorSubject(false);

  sortierkennzeichenListe = [
    ...Array.from({ length: 9 }, (_, index) => String(index + 1)),
    ...Array.from({ length: 26 }, (_, index) =>
      String.fromCharCode(65 + index)
    )
  ];

  buttons_right_add = [
    {
      label: '',
      title: 'Warenkorb leeren',
      icon: 'leeren',
      onclick: () => {
        this.empty();
      },
      class: 'mat-icon-button color_orange tut_warenkorb_clear',
    },
    {
      label: '',
      title: 'Warenkorb umbenennen',
      icon: 'texteingabe',
      onclick: () => {
        this.rename();
      },
      class: 'mat-icon-button color_blue tut_warenkorb_rename',
    },
    {
      label: '',
      title: 'Warenkorb löschen',
      icon: 'loeschen',
      onclick: () => {
        this.delete();
      },
      class: 'mat-icon-button color_red tut_warenkorb_delete',
    }
  ];

  vfCheckRunning = false;

  view_settings: ViewSettings[] | any;
  viewLabelMap = {};

  kategorien = new BehaviorSubject<WarenkorbKategorie[]>([]);

  next_cron_import_run = new BehaviorSubject<string>(null);
  cron_import_enabled = new BehaviorSubject<boolean>(false);

  posUpdatePending = false;

  valutaDate: any;
  liefernAbDate: any;
  reTage: any;

  autoSavePositionTimeouts = {};

  _onDestroy = new Subject<void>();

  showAktionenDefault = false;
  showEinkaufsstatistikWebDefault = false;

  protected readonly parseInt = parseInt;

/**
 * Beschreibt Methode supplierSelected und ihren Rückgabevertrag.
 */
  supplierSelected() {
    const l = this.loader.start();

    this.svc.updateWarenkorb(this.warenkorb).subscribe(m => {
      this.loadCurrentSupplier();
      this.msg.info('Gespeichert!');
      l.stop();
    });
  }

/**
 * Beschreibt Methode getViewLabelBySlug und ihren Rückgabevertrag.
 */
  getViewLabelBySlug(slug: string): string {
    return this.viewLabelMap[slug] ?? '-';
  }

/**
 * Beschreibt Methode selectedEntriesChangeExec und ihren Rückgabevertrag.
 */
  selectedEntriesChangeExec(slug, entries) {
    this.selectedEntriesPerKategorie[slug] = entries;

    const list = [];
    Object.keys(this.selectedEntriesPerKategorie).forEach(k => {
      this.selectedEntriesPerKategorie[k].forEach(e => {
        list.push(e);
      });
    });
    this.selectedEntries = list;
    this.selectedEntriesChange.emit(this.selectedEntries);
  }

/**
 * Beschreibt Methode validateExterneKopfreferenz und ihren Rückgabevertrag.
 */
  validateExterneKopfreferenz() {
    this.externeKopfreferenz_edited = true;
    if (this.warenkorb.externeKopfreferenz && this.warenkorb.externeKopfreferenz.length > 36) {
      this.warenkorb.externeKopfreferenz = this.warenkorb.externeKopfreferenz.substring(0, 36);
    }
  }

/**
 * Beschreibt Methode valutaSelected und ihren Rückgabevertrag.
 */
  valutaSelected(event) {
    this.valuta_edited = true;
    if (event && event.value) {
      this.warenkorb.valutaDate = event && event.value.format('DD.MM.YYYY');
    } else {
      this.warenkorb.valutaDate = null;
    }
  }

/**
 * Beschreibt Methode liefernAbSelected und ihren Rückgabevertrag.
 */
  liefernAbSelected(event) {
    this.liefernAb_edited = true;
    if (event && event.value) {
      this.warenkorb.liefernAb = event && event.value.format('DD.MM.YYYY');
    } else {
      this.warenkorb.liefernAb = null;
    }
  }

/**
 * Beschreibt Methode loadCurrentSupplier und ihren Rückgabevertrag.
 */
  loadCurrentSupplier() {
    if (this.cfg.featuresEnabled(['Lieferantenbestellung']) && this.suppliers.value.length > 0 && this.warenkorb) {
      this.suppliers.value.some(s => {
        if (s.id.toString() == this.warenkorb.supplierId) {
          this.selectedSupplier = s;
          return true;
        } else {
          return false;
        }
      });
    } else {
      this.selectedSupplier = new Supplier();
    }
  }

/**
 * Beschreibt Methode reTageSelected und ihren Rückgabevertrag.
 */
  reTageSelected() {
    this.reTage_edited = true;
  }

/**
 * Beschreibt Methode validChange und ihren Rückgabevertrag.
 */
  validChange(event: any) {
    let countReadyToSend = 0;
    this.warenkorb.entries.forEach(e => {
      if (e.readyToSend) {
        countReadyToSend++;
      }
    });

    this.countReadyToSend.next(countReadyToSend);

    if (event) {
      if (this.selectedSupplier && this.selectedSupplier.commType == 'ePharmGH') {

        this.warenkorb.entries.forEach(e => {

          if (e.artikel.PZN == '' || e.artikel.PZN == null || e.artikel.PZN == undefined) {
            event = false;
            e.defect = true;
            e.defectInfo = 'Verfügbarkeitsprüfung und Bestellung per ePharmGH ohne PZN nicht möglich';
          }
        });
      }
    }
    this.valid.next(event);
  }

/**
 * Beschreibt Methode rename und ihren Rückgabevertrag.
 */
  rename() {
    this.dsvc.form()
      .setTitle('Warenkorb umbenennen')
      .addField('name', 'Bezeichnung')
      .addButton('ok', 'Umbenennen', 'primary')
      .addButton('cancel', 'Abbrechen')
      .show((res) => {
        if (res && res.clicked_id == 'ok') {
          const updatedWarenkorb = { ...this.warenkorb, label: res.data.name };
          const l = this.loader.start();
          this.svc.updateWarenkorb(updatedWarenkorb).subscribe({
            next: m => {
              this.warenkorb.label = m.label;
              this.msg.info('Gespeichert!');
              l.stop();
            },
            error: () => l.stop()
          });
        }
      });
  }

/**
 * Beschreibt Methode updateFields und ihren Rückgabevertrag.
 */
  updateFields() {
    this.detectChanges();
    this.saveFields();
  }

/**
 * Beschreibt Methode loadFields und ihren Rückgabevertrag.
 */
  loadFields() {
    this.settsvc.getUserSettingValue('GUI_ShopWarenkorbColumns').subscribe(f => {
      const fields: string[] = f || [];
      this.preservedActionFields = fields.map((field, index) => ({field, index}))
        .filter(item => this.popupActionFields.includes(item.field));
      this.active_fields = this.cfg.domainconfig?.shop_aktionen_popup
        ? fields.filter(field => !this.popupActionFields.includes(field))
        : fields;
      this.detectChanges();
    });
  }

/**
 * Beschreibt Methode saveFields und ihren Rückgabevertrag.
 */
  saveFields() {
    const fields = [...this.active_fields];
    if (this.cfg.domainconfig?.shop_aktionen_popup) {
      this.preservedActionFields.forEach(({field, index}) => {
        if (!fields.includes(field)) {
          fields.splice(index, 0, field);
        }
      });
    }
    this.settsvc.setUserSettingValue('GUI_ShopWarenkorbColumns', fields).subscribe();
  }

/**
 * Beschreibt Methode loadSettings und ihren Rückgabevertrag.
 */
  loadSettings() {
    this.settsvc.getCustomerSettingValue('ShopImportAutosend').subscribe(s => {
      this.cron_import_enabled.next(s);
    });
  }

/**
 * Beschreibt Methode loadImpCronTime und ihren Rückgabevertrag.
 */
  loadImpCronTime() {
    this.ctsvc.getnextTimeWKImportAutosendTask().subscribe(t => {
      this.next_cron_import_run.next(t);
    });
  }

/**
 * Beschreibt Methode saveWarenkorb und ihren Rückgabevertrag.
 */
  saveWarenkorb() {
    this.note_edited = false;
    this.reTage_edited = false;
    this.valuta_edited = false;
    this.liefernAb_edited = false;
    const l = this.loader.start();

    this.svc.updateWarenkorb(this.warenkorb).subscribe(m => {
      this.msg.info('Gespeichert!');
      l.stop();
    });
  }

/**
 * Beschreibt Methode saveAutoImp und ihren Rückgabevertrag.
 */
  saveAutoImp() {
    const l = this.loader.start('ShopWarenkorbComponent_3');

    this.svc.updateWarenkorb(this.warenkorb).subscribe(m => {
      this.msg.info('Gespeichert!');
      l.stop();
    });
  }

/**
 * Beschreibt Methode change und ihren Rückgabevertrag.
 */
  change() {
    this.group.next(this.group_val);
    this.kvstorage.save4User('Warenkorb_group', this.group.value ? 1 : 0).subscribe();
    this.detectChanges();
  }

/**
 * Beschreibt Methode checkPrimaryWk und ihren Rückgabevertrag.
 */
  checkPrimaryWk() {
    if (this.warenkorb && this.primary_warenkorb && this.warenkorb.id != this.primary_warenkorb.id) {
      const b = new SectionTitleButton();
      b.icon = 'radiobutton-leer';
      b.title = 'Als Haupt-Warenkorb verwenden';
      b.class = 'section_title_button_highlight_green tut_warenkorb_setprimary';
      b.onclick = () => {
        this.svc.primary_warenkorb.next(this.warenkorb);
        this.msg.info('Haupt-Warenkorb geändert!');
      };
      this.buttons_right = [
        b
      ];
    } else {
      this.buttons_right = [];
    }

    this.buttons_right_add.forEach(b => {
      this.buttons_right.push(b);
    });

    this.buttons_rightChange.emit(this.buttons_right);
    this.detectChanges();
  }

/**
 * Beschreibt Methode load und ihren Rückgabevertrag.
 */
  load(silent = false) {
    if (this.warenkorb) {
      this.lockScrollTop = true;
      if (!this.ajax_mode && !this.widget_mode) {
        this.tsvc.setTitle('Warenkorb ' + this.warenkorb.label);
      }

      const kats: WarenkorbKategorie[] = [];
      const hasError = false;
      this.warenkorb.entries.forEach(e => {
        const slug = e.view_slug;
        let found = false;
        kats.forEach(k => {
          if (k.view_slug == slug) {
            k.positionen.push(e);
            found = true;
          }
        });

        if (!found) {
          const k = new WarenkorbKategorie();
          k.positionen = [e];
          k.view_slug = slug;
          k.label = this.viewLabelMap[k.view_slug];
          kats.push(k);
        }
      });
      this.positions = this.warenkorb.entries;
      this.poscount = this.warenkorb.entries.length;
      this.kategorien.next(kats);
      this.detectChanges();

      AppAsyncTimeout.setTimeout(() => {
        this.loadScroll();
      }, 1);

      this.checkPrimaryWk();
    }
  }

/**
 * Beschreibt Methode ngOnDestroy und ihren Rückgabevertrag.
 */
  ngOnDestroy(): void {
    this._onDestroy.next();
    this._onDestroy.complete();

    if (this.update_timeout) {
      clearTimeout(this.update_timeout);
      this.on_update_timeout();
    }
    if (!this.ajax_mode && !this.widget_mode) {
      this.tsvc.resetTitle();
    }
  }

/**
 * Beschreibt Methode ngOnChanges und ihren Rückgabevertrag.
 */
  ngOnChanges(changes: SimpleChanges) {
    const keys = Object.keys(changes);
    if (keys.length == 1 && keys[0] == 'buttons_right') {
    }
    if (changes.warenkorb) {
      this.load();
    }
  }

/**
 * Beschreibt Methode ngOnInit und ihren Rückgabevertrag.
 */
  ngOnInit(): void {
    this.settsvc.getUserSettingValue('ShopWarenkorbOpenAktionenPerDefault').subscribe({next: (state) => {
        if (state) {
          this.showAktionenDefault = true;
        }
      },
      error: (err) => {

      }
    });

    this.settsvc.getUserSettingValue('ShopWarenkorbOpenEKStatWebPerDefault').subscribe({next: (state) => {
        if (state) {
          this.showEinkaufsstatistikWebDefault = true;
        }
      },
      error: (err) => {

      }
    });

    this.kvstorage.load4User('Warenkorb_group').subscribe(group => {
      if (group == 1) {
        this.group.next(true);
        this.group_val = true;
      } else {
        this.group.next(false);
        this.group_val = false;
      }
    });
    if (this.warenkorb && this.warenkorb.valutaDate) {
      AppAsyncTimeout.setTimeout(() => {
        this.valutaDate = moment(this.warenkorb.valutaDate, 'DD.MM.YYYY');
      });
    }

    if (this.warenkorb && this.warenkorb.liefernAb) {
      AppAsyncTimeout.setTimeout(() => {
        this.liefernAbDate = moment(this.warenkorb.liefernAb, 'DD.MM.YYYY');
      });
    }

    this.ssvc.supplier.pipe(takeUntil(this._onDestroy)).subscribe(s => {
      this.suppliers.next(s);
      this.loadCurrentSupplier();
    });

    this.initScrollBox();
    this.loadFields();
    this.vsvc.menu_views$.pipe(takeUntil(this._onDestroy)).subscribe((vs) => {
      this.view_settings = {};
      this.viewLabelMap = {};
      if (vs) {
        vs.forEach(v => {
          this.view_settings[v.slug] = v.settings;
          if (v.settings && v.settings.label) {
            this.viewLabelMap[v.slug] = v.settings.label;
          } else {
            this.viewLabelMap[v.slug] = v.label;
          }
        });
      }
      this.kategorien.value.forEach(kategorie => {
        kategorie.label = this.viewLabelMap[kategorie.view_slug];
      });
      this.detectChanges();
    });
    this.load();
    this.svc.primary_warenkorb$.pipe(takeUntil(this._onDestroy)).subscribe(wk => {
      this.primary_warenkorb = wk;
      this.checkPrimaryWk();
    });
  }

/**
 * Beschreibt Methode addNoteLine und ihren Rückgabevertrag.
 */
  addNoteLine(entry: WarenkorbEntry) {
    entry.print_note_lines[entry.note.length] = false;
    entry.note.push('');
  }

/**
 * Beschreibt Methode deletePosition und ihren Rückgabevertrag.
 */
  deletePosition(entry: WarenkorbEntry) {
    const title = entry.addedByHook === true
      ? 'Automatisch hinzugefügte Position löschen?'
      : 'Position löschen?';
    const message = entry.addedByHook === true
      ? 'Diese Position wurde automatisch in den Warenkorb gelegt. Wenn Sie sie aus dem Warenkorb löschen, bleibt der Artikel in Ihrem persönlichen Bestellprogramm erhalten. Bitte entfernen Sie den Artikel dort ebenfalls, wenn er nicht mehr gewünscht wird.'
      : 'Wollen Sie ' + entry.artikel.ArtikelName + ' wirklich aus dem Warenkorb löschen?';

    this.dsvc.confirm(
      null,
      title,
      message,
      () => {
        this.loader.start('ShopWarenkorbComponent_2');
        this.svc.deleteFromWarenkorbById(this.warenkorb.id, entry.id).subscribe(m => {
          this.reload.emit();
          const i = new WarenkorbActionInfo();
          i.action = 'delete';
          i.info = m;

          this.snackBarSvc.open(ShopWarenkorbActionInfoComponent, i, 2500);

          this.loader.stop('ShopWarenkorbComponent_2');
          this.load(true);
        });
      }, () => {

      }
    );
  }

/**
 * Beschreibt Methode getSumme und ihren Rückgabevertrag.
 */
  getSumme(): number {
    let summ = 0;
    this.positions.forEach(e => {
      if (e.basisverrechnungspreis !== null) {
        summ += e.menge * e.basisverrechnungspreis;

      } else {
        summ += e.menge * e.artikel.Kundeneinkaufspreis;
      }
    });

    return summ;
  }

/**
 * Beschreibt Methode getKatSumme und ihren Rückgabevertrag.
 */
  getKatSumme(kat: WarenkorbKategorie) {
    let summ = 0;
    this.positions.forEach(e => {
      if (e.view_slug == kat.view_slug) {
        if (e.basisverrechnungspreis !== null) {
          summ += e.menge * e.basisverrechnungspreis;

        } else {
          summ += e.menge * e.artikel.Kundeneinkaufspreis;
        }
      }
    });

    return summ;
  }

/**
 * Beschreibt Methode vfCheckWk und ihren Rückgabevertrag.
 */
  vfCheckWk($event = null) {
    if ($event) {
      $event.stopImmediatePropagation();
      $event.preventDefault();
    }
    this.vfCheckRunning = true;


    const l = this.loader.start();
    const checkEntries = [];
    const toAddEntries = [];

    this.warenkorb.entries.forEach(entry => {
      checkEntries.push(entry);
    });

    const checkDataEntry = [];
    const checkData = [];
    checkEntries.forEach(e => {
      let menge = 0;
      // tslint:disable-next-line:radix
      menge += parseInt(String(e.menge));
      if (e.freimenge) {
        // tslint:disable-next-line:radix
        menge += parseInt(String(e.freimenge));
      }
      checkData.push({
        view_slug: e.view_slug,
        artikelnummer: e.artikel.ArtikelNummer,
        artikelpzn: e.artikel.PZN,
        artikelmenge: menge,
        artikelstatuscode: e.artikel.VerfuegbarkeitsstatusCode,
      });
      checkDataEntry.push(e);
    });

    this.vsvc.multiVerfuegbarkeitBySlug(checkData, this.selectedSupplier.id ?? null).subscribe({
      next: (responses) => {
        const map = [];

        responses.forEach((r, i) => {
          map[this.positions[i].id] = r;
        });

        this.positionVerfuegbarkeiten = map;

        this.detectChanges();

        l.stop();
      },
      error: (e) => {
        l.stop();
      }
    });
  }

/**
 * Beschreibt Methode _sendWK und ihren Rückgabevertrag.
 */
  _sendWK() {
    if (this.update_timeout) {
      clearTimeout(this.update_timeout);

      this.on_update_timeout_done = () => {
        this.router.navigateByUrl('/shop/warenkorb/' + this.warenkorb.id + '/checkout');
      };

      this.on_update_timeout();

    } else {
      this.router.navigateByUrl('/shop/warenkorb/' + this.warenkorb.id + '/checkout');
    }
  }

/**
 * Beschreibt Methode sendWk und ihren Rückgabevertrag.
 */
  sendWk($event) {
    $event.stopImmediatePropagation();
    $event.preventDefault();

    if (this.usvc.user.value.readonly_impersonated) {
      return;
    }

    if (this.countReadyToSend.value != this.warenkorb.entries.length) {
      this.dsvc.confirm('frage', 'Nicht alle Positionen zum Senden bereit',
        'Wollen Sie die bereiten Positionen (' + this.countReadyToSend.value + ') senden?', () => {
          this._sendWK();
        });
    } else {
      this._sendWK();
    }
  }

/**
 * Beschreibt Methode updatePosition und ihren Rückgabevertrag.
 */
  updatePosition(entry: WarenkorbEntry) {
    if (!entry.valid) {
      entry.dirty = false;
      return;
    }

    const previousMenge = entry.gui_previousMenge;
    const needsDecision = previousMenge !== undefined
      && previousMenge !== entry.menge
      && AppImportHinweisService.needsDecision(
        entry.artikel,
        entry.menge,
        entry.hatImportHinweisZugestimmt
      );

    if (needsDecision) {
      this.importHinweisSvc.open(entry.artikel).subscribe((result: ImportHinweisResult) => {
        if (result.decision === 'confirm') {
          entry.hatImportHinweisZugestimmt = true;
          entry.importHinweisOption = result.option;
          entry.importHinweisEntscheidung = 'confirm';
        } else {
          entry.menge = 3;
          entry.hatImportHinweisZugestimmt = false;
          entry.importHinweisOption = null;
          entry.importHinweisEntscheidung = 'reduce';
          entry.gui_importHinweisAbgelehnt = true;
          this.msg.info('Die Menge wurde wegen der abgelehnten Importbestätigung auf 3 Stück reduziert.');
        }
        this.persistPosition(entry);
      });
      return;
    }

    this.persistPosition(entry);
  }

  private persistPosition(entry: WarenkorbEntry) {
    entry.dirty = true;

    const pn = [];
    entry.note.forEach((v, i) => {
      pn[i] = false;
      if (entry.print_note_lines && entry.print_note_lines[i] === true) {
        pn[i] = true;
      }
    });

    entry.print_note_lines = pn;

    this.svc.updateForWarenkorbById(this.warenkorb.id, entry).subscribe({
      next: () => {
        entry.dirty = false;
        if (this.on_update_timeout_done) {
          this.on_update_timeout_done();
          this.on_update_timeout_done = undefined;
        }
        this.reload.emit();
      },
      error: () => {
        entry.dirty = false;
        this.on_update_timeout_done = undefined;
        this.svc.getWarenkorbById(this.warenkorb.id).subscribe({
          next: warenkorb => {
            this.warenkorb = warenkorb;
            this.load(true);
            this.reload.emit();
          },
          error: () => {
            if (entry.gui_previousMenge !== undefined) {
              entry.menge = entry.gui_previousMenge;
            }
            this.detectChanges();
          }
        });
      }
    });
  }

/**
 * Beschreibt Methode trackByFn und ihren Rückgabevertrag.
 */
  trackByFn(index, item) {
    return index;
  }

/**
 * Beschreibt Methode clear und ihren Rückgabevertrag.
 */
  clear() {
    this.dsvc.confirm(
      null,
      'Warenkorb leeren?',
      'Wollen Sie den Warenkorb wirklich leeren?',
      () => {
        const l = this.loader.start();
        this.svc.emptyWarenkorb(this.warenkorb).subscribe(s => {
          if (s) {
            this.msg.info('Geleert!');
          } else {
            this.msg.info('Fehlgeschlagen!');
          }
          l.stop();
        }, () => {
          l.stop();
        });

      }, () => {

      }
    );
  }


/**
 * Beschreibt Methode markDirty und ihren Rückgabevertrag.
 */
  markDirty(entry: WarenkorbEntry, timeoutMs: number = 3000) {
    entry.dirty = true;

    if (this.autoSavePositionTimeouts[entry.id]) {
      clearTimeout(this.autoSavePositionTimeouts[entry.id]);
    }
    this.autoSavePositionTimeouts[entry.id] = setTimeout(() => {
      if (entry.dirty == true) {
        this.positionAutoSave(entry);
      }
    }, timeoutMs);
  }

/**
 * Beschreibt Methode positionAutoSave und ihren Rückgabevertrag.
 */
  positionAutoSave(entry: WarenkorbEntry) {
    if (entry.dirty) {
      if (this.autoSavePositionTimeouts[entry.id]) {
        clearTimeout(this.autoSavePositionTimeouts[entry.id]);
      }
      const print_lines = [];
      const pn = [];
      entry.note.forEach((v, i) => {
        pn[i] = false;
        if (entry.print_note_lines && entry.print_note_lines[i] === true) {
          pn[i] = true;
        }
      });

      entry.print_note_lines = pn;

      if (this.note_autosave_timeout) {
        clearTimeout(this.note_autosave_timeout);
      }
      this.updatePosition(entry);
    }
  }

/**
 * Beschreibt Methode deleteNoteLine und ihren Rückgabevertrag.
 */
  deleteNoteLine(entry: WarenkorbEntry, idx: number) {
    if (entry.note[idx] != '') {
      this.dsvc.confirm(
        null,
        'Textzeile löschen?',
        'Wollen Sie "' + entry.note[idx] + '" wirklich löschen?',
        () => {
          entry.note.splice(idx, 1);
          this.updatePosition(entry);
        }, () => {

        }
      );
    } else {
      entry.note.splice(idx, 1);
      this.updatePosition(entry);
    }
  }

/**
 * Beschreibt Methode duplicatePosition und ihren Rückgabevertrag.
 */
  duplicatePosition(entry: WarenkorbEntry) {
    if (entry.addedByHook === true) {
      return;
    }

    this.svc.duplicateFromWarenkorbById(this.warenkorb.id, entry.id).subscribe(m => {
      this.load(true);
      const i = new WarenkorbActionInfo();
      i.action = 'add';
      i.info = m;

      this.snackBarSvc.open(ShopWarenkorbActionInfoComponent, i, 2500);
    });
  }

/**
 * Beschreibt Methode delete und ihren Rückgabevertrag.
 */
  delete() {
    this.dsvc.confirm(
      null,
      'Warenkorb löschen?',
      'Wollen Sie den Warenkorb wirklich löschen?',
      () => {
        this.svc.deleteWarenkorb(this.warenkorb).subscribe(m => {
          const i = new WarenkorbActionInfo();
          i.action = 'wkdelete';
          i.info = m;

          this.snackBarSvc.open(ShopWarenkorbActionInfoComponent, i, 2500);
        });
        this.backsvc.back();
      }, () => {

      }
    );
  }

/**
 * Beschreibt Methode empty und ihren Rückgabevertrag.
 */
  empty() {
    this.dsvc.confirm(
      null,
      'Warenkorb leeren?',
      'Wollen Sie den Warenkorb wirklich leeren?',
      () => {
        this.svc.emptyWarenkorb(this.warenkorb).subscribe(m => {
          const i = new WarenkorbActionInfo();
          i.action = 'wkempty';
          i.info = m;

          this.snackBarSvc.open(ShopWarenkorbActionInfoComponent, i, 2500);
        });
      }, () => {

      }
    );
  }

  private initScrollBox() {
    if (this.wkscroll && this.wkscroll.SimpleBar) {
      this.wkscroll.SimpleBar.getScrollElement().addEventListener('scroll', (e) => {
        if (!this.lockScrollTop) {
          this.scrollTop = this.wkscroll.SimpleBar.getScrollElement().scrollTop;
        }
      });
    } else {
      AppAsyncTimeout.setTimeout(() => {
        this.initScrollBox();
      }, 200);
    }
  }

  private loadScroll() {
    if (this.wkscroll && this.wkscroll.SimpleBar) {
      this.lockScrollTop = false;
      if (this.scrollTop) {
        this.wkscroll.SimpleBar.getScrollElement().scrollTop = this.scrollTop;
      }
    } else {
      AppAsyncTimeout.setTimeout(() => {
        this.loadScroll();
      }, 200);
    }
  }

  private detectChanges() {
    if (!this.cd['destroyed']) {
      this.cd.detectChanges();
    }
  }
}
